import { useAuthStore } from '@/stores/auth';

interface NuxtContext {
	route: import('vue-router').Route;
	error: (params: { statusCode: number; message?: string }) => void;
	[key: string]: any;
}

/**
 * Interfaccia per i metadati delle route che includono restrizioni di ruolo
 */
interface RouteMetaWithRestrictions {
	restrictedTo?: string[];
	[key: string]: any;
}

/**
 * Middleware per il controllo dei permessi basato sui ruoli utente
 * Verifica che l'utente abbia i ruoli necessari per accedere alla route corrente
 *
 * @param context - Contesto Nuxt con store, route e funzione error
 * @returns void - La funzione error() interrompe l'esecuzione se necessario
 */
export default function profiledRouting(context: NuxtContext): void {
	const { route, error } = context;

	// Usa Pinia invece di Vuex
	const authStore = useAuthStore();
	const userRoles: string[] = authStore.roles;
	const routeMeta = route.meta as RouteMetaWithRestrictions[];

	// Controlla ogni meta definito nella route
	for (const meta of routeMeta) {
		if (meta.restrictedTo && Array.isArray(meta.restrictedTo)) {
			// Verifica se l'utente ha almeno uno dei ruoli richiesti
			const hasRequiredRole = userRoles.some((userRole) => meta.restrictedTo!.includes(userRole));

			if (!hasRequiredRole) {
				return error({ statusCode: 401 });
			}
		}
	}
}
